function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 9h-2V3a2.003 2.003 0 00-2-2H2a2.003 2.003 0 00-2 2v10a2.003 2.003 0 002 2h2v6a2.003 2.003 0 002 2h16a2.003 2.003 0 002-2V11a2.003 2.003 0 00-2-2zm0 4H6v-2h16zM18 3v2H2V3zM2 13V7h16v2H6a2.003 2.003 0 00-2 2v2zm4 8v-6h16v6z",
  "data-name": "Layer 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}));